export default __webpack_public_path__ + "static/media/elevate-dmb-4.b0d9847a.png";